export const CAR_STATUS_VARIANTS = {
  pending: 'PENDING',
  active: 'ACTIVE',
  inactive: 'INACTIVE',
  rejected: 'REJECTED',
};

export const CAR_STATUS_OPTIONS = [
  CAR_STATUS_VARIANTS.pending,
  CAR_STATUS_VARIANTS.active,
  CAR_STATUS_VARIANTS.inactive,
  CAR_STATUS_VARIANTS.rejected,
];
